<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="titlepage">
<span aria-label="iii" id="pg_iii" role="doc-pagebreak"><figure class="TIT" id="tit"><img alt="Everything is Under Control by Phyllis Grant" class="img90" src="images/title.jpg"/>
</figure>
</span></section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?547aaf0c